import React from 'react'
import moment from 'moment'
import NavLink from '../../components/Routes/NavLink';

import WarrantyList from '../../components/Warranty/WarrantyList.jsx'
import { warranties } from '../../core/controllers/Warranties'

export default class WarrantyTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            expiringWarranties: 0,
            warrantiesUsed: 0,
            activeWarranties: 0,
            expiredWarranties: 0
        };
    }

    componentDidMount() {
        var self = this;
        warranties.getWarrantyStats(function(response) {
            const stats = response.data;
            self.setState({
                expiringWarranties: stats.expiring_this_month,
                warrantiesUsed: stats.warranties_used,
                activeWarranties: stats.active_warranties,
                expiredWarranties: stats.expired_warranties
            })
        });
    }

    render(){
        const expiringWarranties = this.state.expiringWarranties;
        const warrantiesUsed = this.state.warrantiesUsed;
        const activeWarranties = this.state.activeWarranties;
        const expiredWarranties = this.state.expiredWarranties;
        return (
            <div>
                <div class="row">
                    <div class="main-page-header-row col-md-12">
                        <div class="col-md-3 col-sm-6 col-xs-6">
                            <span class="main-page-header-title">Warranties</span>
                        </div>
                        <div class="col-md-2 col-md-offset-7 col-sm-6 col-xs-12">
                            <NavLink to={"/warranty/new"}>
                                <button type="button" id="add-warranty" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off">
                                    Add Warranty
                                </button>
                            </NavLink>
                        </div>
                    </div>
                </div>
                <br />
                <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="info-box">
                        <span class="info-box-icon orange-icon-circle">
                            <i class="pe-7s-attention"></i>
                        </span>
                        <div class="info-box-content">
                            <span class="info-box-text">
                                <span>Warranties Expiring in </span><span>{ moment().format('MMMM') }</span>
                            </span>
                            <span class="info-box-number orange-info-number">
                                <span>{ expiringWarranties }</span>
                                <small></small>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 col-xs-12" style={window.innerWidth < 992 && window.innerWidth > 767 ? {marginBottom: 28} : {}}>
                    <div class="info-box">
                        <span class="info-box-icon blue-icon-circle">
                            <i class="pe-7s-bandaid"></i>
                        </span>
                        <div class="info-box-content">
                            <span class="info-box-text">
                                <span>Warranties Used in </span><span>{ moment().format('MMMM') }</span>
                            </span>
                            <span class="info-box-number blue-info-number">
                                <span>{ warrantiesUsed }</span>
                                <small></small>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="info-box">
                        <span class="info-box-icon green-icon-circle">
                            <i class="pe-7s-gleam"></i>
                        </span>
                        <div class="info-box-content">
                            <span class="info-box-text">
                                <span>Active Warranties</span>
                            </span>
                            <span class="info-box-number green-info-number">
                                <span>{ activeWarranties }</span>
                                <small></small>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="info-box">
                        <span class="info-box-icon gray-icon-circle">
                            <i class="pe-7s-timer"></i>
                        </span>
                        <div class="info-box-content">
                            <span class="info-box-text">
                                <span>Expired Warranties</span>
                            </span>
                            <span class="info-box-number gray-info-number">
                                <span>{ expiredWarranties }</span>
                                <small></small>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h4 class="title">Warranty Management</h4>
                            <p class="category">Complete list of all warranties</p>
                        </div>
                        <WarrantyList />
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/Warranty/Warranty.jsx